import { ContentType } from "taskpane/models/enums";
import { IQueryResponse } from "taskpane/models/interfaces";
import { OnReady } from "taskpane/models/types";
import { getQueryErrorDescription, getQueryErrorInvalidFormat } from "taskpane/resources";
import { getFormUrlEncodedData } from "taskpane/utils";

export interface IPostData {
  data: object;
  contentType?: ContentType;
}

const useQuery = (
  url: string,
  method: "GET" | "POST" = "GET",
  onReady?: OnReady<unknown>,
  postData?: IPostData,
  async: boolean = true
): void => {
  const xhr: XMLHttpRequest = new XMLHttpRequest();

  xhr.open(method, `/proxy/${url}`, async);

  if (postData) {
    const { data, contentType } = postData;

    xhr.setRequestHeader("Content-Type", contentType || ContentType.json);

    switch (contentType) {
      case ContentType.formUrlEncoded: {
        xhr.send(getFormUrlEncodedData(data));
        break;
      }
      default: {
        xhr.send(JSON.stringify(data));
      }
    }
  } else {
    xhr.send();
  }

  if (async) {
    xhr.onload = () => {
      onQueryReady(xhr.status, xhr.statusText, xhr.responseText, onReady);
    };
  } else {
    onQueryReady(xhr.status, xhr.statusText, xhr.responseText, onReady);
  }
};

const onQueryReady = (statusCode: number, statusText: string, responseText: string, onReady?: OnReady<unknown>) => {
  const result: IQueryResponse<unknown> = {
    errorMessage: "",
    response: null,
    statusCode,
  };

  if (statusCode !== 200) {
    result.errorMessage = getQueryErrorDescription(statusCode, statusText);
  } else {
    try {
      result.response = JSON.parse(responseText);
    } catch (e) {
      result.errorMessage = getQueryErrorInvalidFormat();
    }
  }

  if (onReady) {
    return onReady(result);
  }
};

export default useQuery;
